"use client";

import { HandWavingIcon } from "@phosphor-icons/react";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Typography } from "@/components/ui/typography";
import { useSupportEmail } from "@/hooks/use-support-email";
import { useTranslation } from "@/i18n/client";

interface SupportMenuItemProps {
  variant?: "sidebar" | "topbar";
}

function getMenuItemClassName(variant: SupportMenuItemProps["variant"]): string {
  if (variant === "topbar") {
    return "mx-2 cursor-pointer rounded-lg px-3 py-2 focus:bg-primary-50";
  }

  return "h-6 w-full cursor-pointer rounded-lg px-1 py-1 focus:bg-primary-100 hover:bg-primary-100";
}

export default function SupportMenuItem({ variant = "sidebar" }: SupportMenuItemProps) {
  const { t: tSidebar } = useTranslation("sidebar");
  const { handleSupportClick } = useSupportEmail();

  if (variant === "topbar") {
    return (
      <DropdownMenuItem className={getMenuItemClassName(variant)} onClick={handleSupportClick}>
        <HandWavingIcon size={16} weight="regular" className="mr-3 text-neutral-600" />
        <Typography variant="label 3" className="text-neutral-700">
          {tSidebar("support")}
        </Typography>
      </DropdownMenuItem>
    );
  }

  return (
    <DropdownMenuItem className={getMenuItemClassName(variant)} onClick={handleSupportClick}>
      <div className="flex items-center gap-2">
        <HandWavingIcon size={16} weight="duotone" className="size-4 text-neutral-700" />
        <Typography variant="label 6" className="text-neutral-700">
          {tSidebar("support")}
        </Typography>
      </div>
    </DropdownMenuItem>
  );
}
